import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/components/Index'
import RealisationsPage from '@/components/RealisationsPage'
import ServicesEquipment from '@/components/ServicesEquipment'
import AboutUs from '@/components/AboutUs'
import JoinUs from '@/components/JoinUs'

import Cintrage from '@/components/services/Cintrage'
import Conception from '@/components/services/Conception'
import Pliage from '@/components/services/Pliage'
import Soudure from '@/components/services/Soudure'
import Usinage from '@/components/services/Usinage'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Index',
      component: Index
    },
    {
      path: '/services',
      component: ServicesEquipment,
      children: [
        {
          path: '/',
          name: 'Services.Cintrage',
          component: Cintrage
        },
        {
          path: 'Conception',
          name: 'Services.Conception',
          component: Conception
        },
        {
          path: 'Pliage',
          name: 'Services.Pliage',
          component: Pliage
        },
        {
          path: 'Soudure',
          name: 'Services.Soudure',
          component: Soudure
        },
        {
          path: 'Usinage',
          name: 'Services.Usinage',
          component: Usinage
        }
      ]
    },
    {
      path: '/equipements',
      name: 'Equipements',
      component: ServicesEquipment
    },
    {
      path: '/realisation',
      name: 'RealisationsPage',
      component: RealisationsPage
    },
    {
      path: '/aboutus',
      name: 'AboutUs',
      component: AboutUs
    },
    {
      path: '/joinus',
      name: 'JoinUs',
      component: JoinUs
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js